export default __webpack_public_path__ + "static/2.3.2/media/batteriesEditBanner.641e2d05.svg";